"use client";

import _toConsumableArray from "/codebuild/output/src934747875/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isBackdrop } from "./63XF7ACK.js";
import { walkTreeOutside } from "./AOUGVQZ3.js";
import { setAttribute } from "./K2ZF5NU7.js";

// src/dialog/utils/disable-accessibility-tree-outside.ts
function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}
function disableAccessibilityTreeOutside(id, elements) {
  var cleanups = [];
  var ids = elements.map(function (el) {
    return el == null ? void 0 : el.id;
  });
  walkTreeOutside(id, elements, function (element) {
    if (isBackdrop.apply(void 0, [element].concat(_toConsumableArray(ids)))) return;
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });
  var restoreAccessibilityTree = function restoreAccessibilityTree() {
    for (var _i = 0, _cleanups = cleanups; _i < _cleanups.length; _i++) {
      var cleanup = _cleanups[_i];
      cleanup();
    }
  };
  return restoreAccessibilityTree;
}
export { hideElementFromAccessibilityTree, disableAccessibilityTreeOutside };